import * as types from "./../../store/mutation-types.js";
import * as globalMutationTypes from "@/store/mutation-types.js";

import icons from "@/mixins/icons.js";
import bo from "@/mixins/basic-operations.js";
import ValidationService from '@/services/validation.service.js'
import AS from "./../../services/agenda-global/agenda.service.js";
import _ from "lodash";

import RSM from "wisaapp-webstudent/src/mixins/right-side-menu.js";
import { getAccountInfo } from "../../store/actions.js";
// import tab from "@/components/utils/tab/tab.vue";
const agendaService = new AS();

const validationService = new ValidationService()
export default {
  name: "opleiding",
  mixins: [icons, bo, RSM],
  // components: {
  //   // tab
  // },
  data: function() {
    return {
    
      screenRights:this.$store.state.userInfo.screensRightsInformation,
      cursistInfo:this.$store.state.wstudent.cursistInfo,
      opleidingList:[],
      moduleList:[],
      gevolgdeopleidingList:[],
      selectedOpleiding:''
    
    };
  },

  created: function() {
    this.$store.commit("wstudent/" + types.ZET_CURRENT_SCREEN, "opleiding");
  },
  beforeCreate: function() {
    let veranderpaswoord = this.$store.state.userInfo.loggedInUserInformation.UserData.veranderpaswoord;
    // eslint-disable-next-line
    if (Object.keys(WISA).length === 0 || veranderpaswoord || veranderpaswoord === undefined) {
      this.$router.push("/");
    }
  },
  computed: {
    getcursistInfo(){
      return this.cursistInfo
    },
    
    uniqueOpleidingList () {
      // return _.uniq(this.opleidingList.map(({ OpleidingsvariantID }) => OpleidingsvariantID))
      return _.uniqBy(this.opleidingList, function (e) {
        return e.OpleidingsvariantID;
      });
    }
  },
  watch: {
   
  },
  mounted: function() {


    this.$store.dispatch("wstudent/" + "getOpleiding", this.cursistInfo[0].ID).then(result => { 
      console.log(result)
      this.opleidingList = result
    })
    this.$store.dispatch("wstudent/" + "getModules",  this.cursistInfo[0].ID).then(result => { 
      console.log(result)
      this.moduleList = result
    })
    this.$store.dispatch("wstudent/" + "getGevolgdeopleiding",  this.cursistInfo[0].ID).then(result => { 
      console.log(result)
      this.gevolgdeopleidingList = result
    })
 


    this.$store.commit(globalMutationTypes.SET_MENUBAR_ITEMS, {
      changePartially: true,
      left: "menu",
      title: 'Opleiding',
      right: []
    });
  },

  methods: {
    selectOpleiding(opleiding){
      this.selectedOpleiding =opleiding
      this.$store.commit("wstudent/" + types.ZET_CURRENT_OPLEIDING, opleiding);
      this.$router.push("/opleiding/module");
    }
    
  }
};
